// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumbs_breadcrumb__zCG9T","arrow":"breadcrumbs_arrow__qymoi","active":"breadcrumbs_active__W9yzK"};